<template>
  <div id="app">
    <router-view />
    <SelfLoading v-if="show_loading" />
  </div>
</template>
<script>

import SelfLoading from '@/components/SelfLoading';
import { mapState } from 'vuex';

export default {
  name: 'app',
  data(){
    return{
      
    }
  },

  components:{
    SelfLoading,
  },
  
  computed:{
    ...mapState({
      show_loading: (state) => {
          return state.Public.show_loading
      }
    })
  },
}
</script>
<style lang="scss">
@import './App.scss';
@import './iconfont/iconfont.css';
</style>
